import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import ScrambleButton from "../../widgets/ScrambleButton";

const ScramblePage = ({
  pageList,
  currentPage,
  currentIndex,
  setCurrentIndex,
  setPageList,
  setOverlayVisible,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);
  const [wordList, setWordList] = useState([]);

  useEffect(() => {
    if (currentPage.data.question) {
      setWordList(
        currentPage.data.question
          .filter((element) => element.type === "scramble")
          .map((element) => element.content)[0]
      );
    }
  }, [currentIndex]);

  const handleClickWord = (word) => {
    if (currentPage.isSubmitted) return;
    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: {
            ...prevPage.data,
            question: prevPage.data.question.map((element) => {
              if (element.type === "scramble") {
                return {
                  ...element,
                  input: element.input.includes(word)
                    ? element.input.filter((input) => input !== word)
                    : [...element.input, word],
                };
              }
              return element;
            }),
          },
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;

    const submitCount = currentPage.submitCount + 1;

    const scrambleElement = currentPage.data.question.find(
      (element) => element.type === "scramble"
    );

    let isCorrect = false;
    let newPageList = [];

    if (submitCount < 10) {
      isCorrect =
        scrambleElement.input.map((input) => input.text).join(" ") ===
        currentPage.data.answer;

      newPageList = pageList.map((prevPage, index) => {
        if (index === currentIndex) {
          return {
            ...prevPage,
            data: {
              ...prevPage.data,
              question: prevPage.data.question.map((element) => {
                if (element.type === "scramble") {
                  if (isCorrect) {
                    return element;
                  } else {
                    return {
                      ...element,
                      input: [],
                    };
                  }
                }
                return element;
              }),
            },
            isSubmitted: isCorrect,
            submitCount: submitCount,
          };
        }
        return prevPage;
      });
    } else {
      newPageList = pageList.map((prevPage, index) => {
        if (index === currentIndex) {
          return {
            ...prevPage,
            data: {
              ...prevPage.data,
              question: prevPage.data.question.map((element) => {
                if (element.type === "scramble") {
                  return {
                    ...element,
                    input: currentPage.data.answer.split(" ").map((word) => {
                      return { text: word };
                    }),
                  };
                }
                return element;
              }),
            },
            isSubmitted: true,
            submitCount: submitCount,
          };
        }
        return prevPage;
      });
    }
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    dispatch(
      updateSection({ sectionId: section.id, data: { answer: newPageList } })
    );

    if (submitCount < 10) {
      setOverlayVisible(true);
      setTimeout(() => {
        setOverlayVisible(false);
        if (isCorrect && currentIndex < pageList.length - 1) {
          setTimeout(() => {
            setCurrentIndex(currentIndex + 1);
          }, 200);
        }
      }, 600);
    } else {
      alert(
        "제출 횟수를 초과하였습니다. 정답을 확인하고, 다음 문제로 넘어가세요."
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
        }}
      >
        주어진 영어 문장을 바탕으로 문장을 완성하세요.
      </div>
      <div
        style={{
          fontSize: "28px",
        }}
      >
        {currentPage.data.question && (
          <div style={{ wordBreak: "break-word", display: "inline" }}>
            {currentPage.data.question
              .map((element) => {
                if (element.type === "scramble") {
                  const blankLength = element.length;
                  const userAnswer = element.input;

                  return userAnswer
                    .map((answer) => answer.text)
                    .join(" ")
                    .concat(" ")
                    .padEnd(blankLength, "_");
                } else {
                  return element.content;
                }
              })
              .join(" ")}
          </div>
        )}
      </div>
      <div style={{ fontSize: "20px", color: "#737373" }}>
        {currentPage.data.kor}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "30px",
        }}
      >
        {wordList.length > 0 && (
          <ScrambleButton
            wordList={wordList.slice(0, Math.ceil(wordList.length) / 2)}
            currentPage={currentPage}
            handleClickWord={handleClickWord}
            type={"analysis"}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "30px",
        }}
      >
        {wordList.length > 0 && (
          <ScrambleButton
            wordList={wordList.slice(Math.ceil(wordList.length) / 2)}
            currentPage={currentPage}
            handleClickWord={handleClickWord}
            type={"analysis"}
            key={2}
          />
        )}
      </div>
      <button
        style={{
          position: "absolute", // 부모(80% width) 안에서 절대 위치
          bottom: "90px", // 최하단으로부터 10px 떨어짐
          right: "60px", // 우측으로부터 10px 떨어짐
          padding: "10px 35px",
          backgroundColor: currentPage.isSubmitted ? "#EBEBEB" : "#2D2D2D",
          color: currentPage.isSubmitted === true ? "#737373" : "white",
          border: "none",
          fontSize: "18px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={() => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default ScramblePage;
